<script>
    /*
    	ServiceFieldsGroup2.svelte

        Location Info - 6 fields

        Expandable/Collapsible and contains a predetermined set of DataFields
    */

    import { onMount } from 'svelte';
    import { ADDRESS_LINE1, CITY, STATE, POSTAL_CODE, COUNTY, COUNTRY } from '../../common/constants.js';
    import { shallowArraysEqual } from '../../common/utils.js';

    // TCARE components
    import DataTextField from '../data-fields/DataTextField.svelte';
    import FieldGroupExpandBar from './FieldGroupExpandBar.svelte';

    // SMUI components

    // const FIELDS = [ ADDRESS_LINE1, CITY, STATE, POSTAL_CODE, COUNTY, COUNTRY ];
    const GROUP_TITLE = 'Location Information';

    export let store;                   // store is a Service store - not just data!
    export let leftService;
    export let rightService;
    export let onCopyValue;
    export let isEditable;
    export let isOpen;
    export let showDiffs;               // bypass the strike-through and highlighting

    $: apiData = $store.apiData;
    $: isExpanded = isOpen;

    onMount(() => {
        // console.log('ServiceFieldsGroup2 onMount');
    })

    const toggleIsExpanded = () => {
        isExpanded = !isExpanded;
    }

    // TODO: could move these to common area
    const isFieldDiff = (propName) => {
        if (!leftService) return false;
        if (!rightService) return false;
        return leftService[propName] !== rightService[propName];
    }

</script>

<style>
    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="field-group">

    <FieldGroupExpandBar title={GROUP_TITLE} {isExpanded} {toggleIsExpanded} />

    {#if apiData && isExpanded}
        <div class="fields-area">

            <!-- left and right blocks in a fluid row -->
            <div class="flex-row ai-start fluid">

                <div class="flex-block w-49">
                    <DataTextField
                        bind:value={apiData[ADDRESS_LINE1]}
                        propName={ADDRESS_LINE1}
                        label={'Address'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(ADDRESS_LINE1)}
                        isNewDiff={isFieldDiff(ADDRESS_LINE1)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        {showDiffs}
                    />
                    <DataTextField
                        bind:value={apiData[CITY]}
                        propName={CITY}
                        label={'City'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(CITY)}
                        isNewDiff={isFieldDiff(CITY)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        {showDiffs}
                    />
                    <DataTextField
                        bind:value={apiData[STATE]}
                        propName={STATE}
                        label={'State'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(STATE)}
                        isNewDiff={isFieldDiff(STATE)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        {showDiffs}
                    />
                </div>

                <div class="flex-block w-49">
                    <DataTextField
                        bind:value={apiData[POSTAL_CODE]}
                        propName={POSTAL_CODE}
                        label={'ZIP Code'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(POSTAL_CODE)}
                        isNewDiff={isFieldDiff(POSTAL_CODE)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        {showDiffs}
                    />
                    <DataTextField
                        bind:value={apiData[COUNTY]}
                        propName={COUNTY}
                        label={'County'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(COUNTY)}
                        isNewDiff={isFieldDiff(COUNTY)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        {showDiffs}
                    />
                    <DataTextField
                        bind:value={apiData[COUNTRY]}
                        propName={COUNTRY}
                        label={'Country'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(COUNTRY)}
                        isNewDiff={isFieldDiff(COUNTRY)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        {showDiffs}
                    />
                </div>
            </div>
        </div>
    {/if}
</div>
